module.exports = __webpack_public_path__ + "assets/img/odeabank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/odeabank@2x.png
// module id = 138
// module chunks = 0